/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jul 10 2024
 **/

import styled from "@emotion/styled";

export const StyledTable = styled.table`
	table {
		width: 100%;
		border-spacing: 0;
		border-collapse: separate;
	}

	th:first-of-type {
		border-top-left-radius: 10px;
		border-style: hidden;
	}
	th:last-of-type {
		border-top-right-radius: 10px;
	}
`;

export const TableHeader = styled.tr`
	background-color: ${({ theme }) => theme.colors.accent_00_100};
	border-bottom: ${({ theme }) => theme.colors.accent_20_60};
	height: 40px;
	border-radius: 8px;
`;

export const StyledTh = styled.th`
	padding: 10px 20px;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	border-left: 1px solid white;
`;

export const StyledTd = styled.td`
	padding: 10px 20px;
	flex-direction: row;
	text-align: center;
	justify-content: center;
	align-items: center;
	border-right: 1px solid white;
	border-bottom: 1px solid ${({ theme }) => theme.colors.accent_00_100};
`;

export const StyledTr = styled.tr<{ selected: boolean }>`
	display: table-row;
	background-color: ${({ theme, selected }) => (selected ? theme.colors.neutral_10_80 : null)};
	:hover {
		background-color: ${({ theme }) => theme.colors.neutral_10_80};
	}
	cursor: pointer;
`;
